module.exports = __webpack_public_path__ + "img/abkhazia.d4bc019.webp";